import './index.css';
function DailyViewers() {
  return (
    <div className="daily_viewers pt-20 text-white" id="daily_viewers">
      <h1 className="text-5xl">DAILY VIEWERS PLANS</h1>
    </div>
  );
}

export default DailyViewers;